import { FileDown } from "lucide-react";
import { MAILTO } from "@/lib/site";

const LOGOS = [
  {
    name: "FDA",
    src: "/logos/fda-registered.svg",
    alt: "FDA Registered — facility infrastructure",
  },
  {
    name: "USDA",
    src: "https://upload.wikimedia.org/wikipedia/commons/e/ea/USDA_organic_seal.svg",
    alt: "USDA Organic seal",
  },
  {
    name: "FSSAI",
    src: "https://upload.wikimedia.org/wikipedia/en/e/e2/FSSAI_logo.png",
    alt: "Food Safety and Standards Authority of India (FSSAI) logo",
  },
  { name: "GMP", src: "/logos/who-gmp-clean.png", alt: "WHO-GMP Certified — Good Manufacturing Practice" },
  { name: "CERT", src: "/logos/onecert-clean.png", alt: "OneCert Certified Organic" },
];

const TILES = ["Company Profile", "Product Brochure", "Certificate of Analysis"];
const ON_REQUEST = [
  "Product Specification Sheet",
  "Fatty Acid Profile",
  "Heavy Metals Report",
  "Microbiology Report",
  "Pesticide Residue Report",
  "USDA Organic Documentation",
  "Export Documentation Packet",
];

export default function Quality() {
  return (
    <section id="quality" className="section section-dark" data-testid="quality-section">
      <div className="wrap">
        <div className="section-head">
          <h2>Quality &amp; Documentation</h2>
          <p className="copy" style={{ marginTop: 12 }}>
            We support buyer evaluation with product specifications, COAs, testing reports, USDA Organic
            documentation where applicable, and shipment/export documentation for qualified commercial enquiries.
          </p>
        </div>

        <div className="logo-row logo-row-5">
          {LOGOS.map((l) => (
            <div
              key={l.name}
              className="logo-card"
              data-testid={`logo-${l.name.toLowerCase().replace(/[^a-z]/g, "-")}`}
            >
              <img
                src={l.src}
                alt={l.alt}
                className="logo-img"
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  if (e.currentTarget.nextElementSibling) {
                    e.currentTarget.nextElementSibling.style.display = "block";
                  }
                }}
              />
              <div className="label" style={{ display: "none" }}>{l.name}</div>
            </div>
          ))}
        </div>

        <div className="download-row">
          {TILES.map((t) => (
            <a
              key={t}
              href={MAILTO}
              className="dl-tile"
              data-testid={`download-${t.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="dl-art">
                <FileDown size={32} />
              </div>
              <h3>{t}</h3>
            </a>
          ))}
        </div>

        <div className="docs-panel" data-testid="available-on-request">
          <div className="docs-label">Available on Request</div>
          <div className="req-grid">
            {ON_REQUEST.map((r) => (
              <span key={r}>{r}</span>
            ))}
          </div>
          <a className="btn btn-primary" href={MAILTO} data-testid="request-buyer-docs">
            Request Buyer Documentation Pack
          </a>
        </div>
      </div>
    </section>
  );
}
